var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"fullscreen-modal",attrs:{"centered":"","title":_vm.selectedTopic['$v']['displayName']},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('topic-tabs',{attrs:{"show-send-button":_vm.showSendButton,"no-header":true},on:{"send":(params) => _vm.emitSend(params)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }